<template>
  <v-row no-gutters class="style-preview" align="center" justify="center">
    <v-col cols="7" class="style-preview-draw-box d-flex justify-center">
      <template v-if="isStyleValid && labelsStyle.attributes && labelsStyle.attributes.length > 0">
        <svg width="100%" height="100%">
          <text
            v-if="labelsStyle['stroke-visible']"
            x="50%"
            y="50%"
            dominant-baseline="middle"
            text-anchor="middle"
            :font-size="labelsStyle['font-size']"
            stroke-linejoin="round"
            :style="labelStrokeDrawStyle"
          >
            {{ 'Lorem ipsum' }}
          </text>
          <text
            x="50%"
            y="50%"
            dominant-baseline="middle"
            text-anchor="middle"
            :font-size="labelsStyle['font-size']"
            :style="labelDrawStyle"
          >
            {{ 'Lorem ipsum' }}
          </text>
        </svg>
      </template>
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: 'StyleDialogLabelsPreview',
  props: {
    isStyleValid: {
      type: Boolean,
      defalt: () => {
        return false;
      },
    },
    labelsStyle: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    labelDrawStyle() {
      const style = {};
      style['fill'] = `${this.labelsStyle['font-color']}`;
      style['font-weight'] = `${this.labelsStyle['font-weight']}`;
      return style;
    },
    labelStrokeDrawStyle() {
      const style = {};
      style['fill'] = `${this.labelsStyle['font-color']}`;
      style['stroke'] = `${this.labelsStyle['stroke-color']}`;
      style['stroke-width'] = `${this.labelsStyle['stroke-width']}`;
      style['font-weight'] = `${this.labelsStyle['font-weight']}`;
      return style;
    },
  },
};
</script>
<style lang="scss" scoped>
.style-preview {
  @include border(top, 1px, rgba(32, 33, 36, 0.18));
  height: 200px;
}
.style-preview-draw-box {
  height: 120px;
  border: 0.8px solid #898989;
  position: relative;
  z-index: 1;
}
.label-draw {
  display: inline-block;
  line-height: 0px;
  position: absolute;
}
</style>
